export default __webpack_public_path__ + "static/media/gamepad-solid.ede3088e.svg";